import { IdTutorialStep } from "../IdTutorialStep";
import { selectTutorialConfigData } from "../selectors/selectTutorialConfigData";
export var checkTutorialQuestClickComplete = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var tutorialStepConfig = selectTutorialConfigData(state).tutorialStepConfig;
    if (tutorialStepConfig.nextStep !== IdTutorialStep.levelUpScreen) {
        return undefined;
    }
    if (action.questFinish.questId !== tutorialStepConfig.questId) {
        return undefined;
    }
    return path;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/checks/checkTutorialQuestClickComplete.ts
// module id = 2495
// module chunks = 3